<template>
  <OrderStatus pathName="product-statuses" />
</template>

<script>
export default {
  name: "ProductStatus",
  components: {
    OrderStatus: () => import("@/components/OrderStatus")
  }
};
</script>
